import React from 'react'
import { Grid } from '@mui/material'
import UserBasicProfileForm from './UserBasicProfileForm'
import UserEmailForm from './UserEmailForm'

export default function UserProfile() {
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            alignContent="center"
        >
            <Grid item xs={12} md={10} lg={8} xl={6}>
                <Grid container rowSpacing={6}>
                    <Grid item xs={12}>
                        <UserBasicProfileForm />
                    </Grid>
                    <Grid item xs={12}>
                        <UserEmailForm />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
